<div class="hug-passage-page">
  <laser-pointer *ngIf="showLaser" [firstHearing]="firstHearing" [secondHearing]="secondHearing"></laser-pointer>


  <main>
    <app-section-loader [loading]="loading"></app-section-loader>
    <section class="pre-engage-header">
      <h2 class="pre-engage-header__title">
        {{lessonDetails?.lesson_plan_name}}
      </h2>
      <div class="pre-engage-header__buttons">
        <button
          *ngIf="lessonDetails?.embedded_video_url"
          mat-raised-button
          color="white"
          class="hug-main-button"
          (click)="openLessonVideo()">
          Phonics Lesson
        </button>

        <button mat-raised-button [color]="showLaser?'primary':'white'" class="hug-main-button hug-laser-btn"
          (click)="toggleLaser()" [disabled]="pingPongGame">
          <img src="../../../assets/assets/images/svg/laser-burst-red.svg" alt="Laser">
          Laser
        </button>
        <button mat-raised-button color="white" class="hug-main-button" (click)="handleUfliSTratergyModal(true)">
          UFLI Strategies
        </button>
        <button mat-raised-button color="white" class="hug-main-button" (click)="tutorTipModalOpen(true)">
          <img src="../../../assets/assets/images/svg/info-blue.svg" alt="info">
          Tutor Tips
        </button>
      </div>
    </section>

    <nav class="hug-psc-navigation">
      <div class="hug-psc-navigation__nav">
        <button (click)="toggleCurrentStep(currentStep - 1)" [disabled]="isSavingLoader">
          <p>Back</p>
          <img src="../../../assets/assets/images/svg/arrow-back.svg" alt="previous">
          <p *ngIf="pingPongGame">1<sup>st</sup> read</p>
          <p *ngIf="secondHearing"> Ping pong game</p>
          <p *ngIf="firstHearing && passageIndex>0"> Passage {{passageIndex}}</p>
          <p *ngIf="firstHearing && passageIndex==0"> Pre engagement</p>
        </button>
      </div>

      <div class="hug-psc-navigation__container">

        <h1 class="text-center mb-4">
          Passage {{passageIndex+1}}: {{passageDetails?.passage_name}}
        </h1>

        <div class="stepper-wrapper">
          <div class="stepper-item" [ngClass]="firstHearing ? 'active' : pingPongGame || secondHearing?'completed':''">
            <div class="step-counter">
              <img src="../../../assets/assets/images/svg/highlighter-2.svg" alt="Highlighter">
            </div>
            <div class="step-name">1<sup>st</sup> read</div>
          </div>
          <div class="stepper-item" [ngClass]="pingPongGame ? 'active' : secondHearing?'completed':''">
            <div class="step-counter">
              <img src="../../../assets/assets/images/svg/ping-pong.svg" alt="">
            </div>
            <div class="step-name">Ping Pong Game</div>
          </div>
          <div class="stepper-item" [ngClass]="secondHearing ? 'active' : ''">
            <div class="step-counter">
              <img src="../../../assets/assets/images/svg/marker-pen-2.svg" alt="">
            </div>
            <div class="step-name">2<sup>nd</sup> read</div>
          </div>
        </div>
      </div>

      <div class="hug-psc-navigation__nav">
        <button (click)="toggleCurrentStep(currentStep+1)">
          <p>Next</p>
          <app-button-loader [isLoading]="isSavingLoader" *ngIf="isSavingLoader"></app-button-loader>
          <img src="../../../assets/assets/images/svg/arrow-next.svg" alt="next" *ngIf="!isSavingLoader">
          <p *ngIf="firstHearing">Ping Pong Game</p>
          <p *ngIf="pingPongGame">2<sup>nd</sup> read</p>
          <p *ngIf="secondHearing && passageIndex<lessonDetails?.passage?.length-1"> Passage {{passageIndex+2}}</p>
          <p *ngIf="secondHearing && passageIndex==lessonDetails?.passage?.length-1"> Post engagement</p>
        </button>
      </div>
    </nav>

    <section class="hug-passage-body">
      <div class="hug-passage-layout">
        <div class="hug-passage-side left">
          <div class="hug-passage-side__note yellow">
            <strong> 1st Read:</strong>
            <article>
               <span
                *ngFor="let word of uniqueFirstReadingWords() let i=index">&nbsp;{{word}}{{i <
                  uniqueFirstReadingWords().length-1? ',' : '' }}</span>
            </article>
          </div>
          <div class="hug-passage-side__note blue" *ngIf="secondHearing || secondReadingWords.length">
            <strong>2nd Read: </strong>
            <article>
               <span
                *ngFor="let word of uniqueSecondReadingWords() let i=index">&nbsp;{{word}}{{i <
                  uniqueSecondReadingWords().length-1 ? ',' : '' }}</span>
            </article>
          </div>
          <div class="hug-passage-side__note green" *ngIf="secondHearing || whipWords.length">
            <strong>W.H.I.P. Words: </strong>
            <article>
              <span *ngFor="let word of whipWords; let i=index">&nbsp;{{word}}{{ i < whipWords.length-1 ? ',' : ''
                  }}</span>
            </article>
          </div>
        </div>

        <div class="hug-passage-layout__inner">
          <div class="hug-passage-container">
            <div class="hug-passage-image-wrap">
              <img [src]="passageImgs.path" alt="Passage image" class="hug-passage-image"
                *ngFor="let passageImgs of images; let i = index" loading="lazy">
            </div>
          </div>
          <div class="hug-passage-side right">
            <div class="hug-passage-side__note green" *ngIf="secondHearing || whipWords.length">
              <strong>W.H.I.P. Words: </strong>
              <article>
                <span *ngFor="let word of whipWords; let i=index">&nbsp;{{word}}{{ i < whipWords.length-1 ? ',' : ''
                    }}</span>
              </article>
            </div>

            <div class="hug-passage-side__phonetics">
              <h1 class="text-center mb-4">
                Phonetics Work Space
              </h1>
              <div class="cloud-shape">
                <textarea #cloudTextarea [(ngModel)]="phoneticsWords"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <article>
        <passage-text *ngIf="passageDetails.summary" [firstReadingWords]="firstReadingWords"
          [secondReadingWords]="secondReadingWords" [whipWords]="whipWords" [paragraph]="passageDetails.summary"
          [secondHearing]="secondHearing" [firstHearing]="firstHearing"
          [firstReadingWordsIndex]="firstReadingWordsIndex" [secondReadingWordsIndex]="secondReadingWordsIndex"
          [isSavingLoader]="isSavingLoader">
        </passage-text>
      </article>
    </section>

    <div class="modal" [ngClass]="{'active':tutorTipModal}" id="modalExample">
      <div class="modal__box">
        <div class="modal__header">
          <h2>Tutor Tips</h2>
          <button class="close" aria-label="Close" (click)="tutorTipModalOpen(false)">×</button>
        </div>
        <div class="modal__body">
          <p [innerHTML]="tutorTip"></p>
        </div>
      </div>
    </div>
    <div class="modal modal--efli" [ngClass]="{'active':ufliStrategyModal}" id="modalExample"
      *ngIf="ufliStrategyClickFlag">
      <div class="modal__box">
        <div class="modal__header hidden">
          <h2>UFLI strategies</h2>
          <button class="close" aria-label="Close" (click)="handleUfliSTratergyModal(false)">×</button>
        </div>
        <div class="modal__body">
          <div class="hug-efli-header">
            <p>
              <strong>UFLI:</strong>
              {{ufliStrategies}}
            </p>
          </div>
          <div class="hug-efli-body">
            <iframe class="w-100 h-100" [src]="sanitizedWordUrl" frameborder="0" allowfullscreen="true"
              webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
          </div>
        </div>
      </div>
    </div>
  </main>
  <div class="modal" [ngClass]="{'active': lessonVideoModal}">
  <div class="modal__box modal__box--video">
    <div class="modal__header">
      <h2>Lesson Video</h2>
      <button class="close" (click)="closeLessonVideo()">×</button>
    </div>

    <div class="modal__body video-modal-body">

      <div class="video-loader" *ngIf="videoLoading">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Loading video...</p>
      </div>

      <div class="video-frame-wrapper">
        <iframe
          *ngIf="sanitizedLessonVideoUrl"
          [src]="sanitizedLessonVideoUrl"
          frameborder="0"
          allowfullscreen
          allow="autoplay; encrypted-media"
          (load)="onVideoLoaded()">
        </iframe>
      </div>

    </div>
  </div>
</div>


  <footer class="hug-tutor-footer">
    <div class="hug-container">
      <p class="hug-copyright">© Help Us Grow Reading Program</p>
    </div>
  </footer>
</div>